const common = {
  siteName: '草榴社区入口',
  siteDescription: '官方直达通道 - 最新可用入口地址与访问指南',
  home: '首页',
  about: '关于我们',
  contact: '联系我们',
  categories: '文章分类',
  latestArticles: '最新文章',
  faq: '常见问题',
  readMore: '阅读更多',
  backToHome: '返回首页',
  notFound: '页面未找到',
  scrollToTop: '回到顶部',
};

export default common;